<app-generate-report-button [ballotReport]="ballotReport"></app-generate-report-button>
